import http from '../../../services/api'
import type { APIPaginatedResponse, Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'
import type { ExpenseApi, ExpenseCreatePayload, ExpenseLineListRowApi, ExpenseUpdatePayload } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

type ExpenseSingleResponse = { data: ExpenseApi }

async function getExpenses(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseApi>>(`${apiPath}expenses${paramString}`)
}

async function getExpenseLines(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getRequestParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseLineListRowApi>>(`${apiPath}expenses/lines${paramString}`)
}

async function getExpense(uuid: string) {
  return await http.get<ExpenseSingleResponse>(`${apiPath}expenses/${uuid}`)
}

async function createExpense(payload: ExpenseCreatePayload) {
  return await http.post<ExpenseSingleResponse>(`${apiPath}expenses`, payload)
}

async function updateExpense(uuid: string, payload: ExpenseUpdatePayload) {
  return await http.put<ExpenseSingleResponse>(`${apiPath}expenses/${uuid}`, payload)
}

async function deleteExpense(uuid: string) {
  return await http.delete<undefined>(`${apiPath}expenses/${uuid}`)
}

const expensesService = {
  getExpenses,
  getExpenseLines,
  getExpense,
  createExpense,
  updateExpense,
  deleteExpense,
}

export default expensesService
